import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import theme from './../readerTheme';
import { DocumentContextProvider } from './DocumentContext';
import { UserRelatedDocumentContextProvider } from './DocumentUserRelatedContext';
import { ReaderConfigurationProvider } from '../features/ReaderConfiguration/ReaderConfigurationContext';
import { IIdentityContext } from '@almamedia-legal-insights/types';
import { UserManagementProvider } from '../features/UserManagement/components/UserManagementContext';
import { usePrefetchQuery } from '@tanstack/react-query';
import { Outlet, useParams } from 'react-router';
import { productMetaQuery } from '../utils/PrefetchUtils';

interface ReadingViewProps {
  identityContext: IIdentityContext;
}

export default function ReaderRoot({
  identityContext,
}: Readonly<ReadingViewProps>) {
  const customTheme = createTheme(theme);
  const { isbn } = useParams();

  // Prefetch product meta for the given ISBN
  usePrefetchQuery(productMetaQuery(isbn as string));

  return (
    <ThemeProvider theme={customTheme} noSsr>
      <CssBaseline />
      <UserManagementProvider identity={identityContext}>
        <DocumentContextProvider>
          <UserRelatedDocumentContextProvider>
            <ReaderConfigurationProvider>
              <Outlet />
            </ReaderConfigurationProvider>
          </UserRelatedDocumentContextProvider>
        </DocumentContextProvider>
      </UserManagementProvider>
    </ThemeProvider>
  );
}
